import React from 'react';
import {
  CalendarToday,
  People,
  Celebration,
  Camera,
  EmojiEvents
} from '@mui/icons-material';
import EventLayout from '../../components/events/EventLayout';
import BackButton from '../../components/events/BackButton';
import EventHero from '../../components/events/EventHero';
import EventMeta from '../../components/events/EventMeta';
import ImageCarousel from '../../components/events/ImageCarousel';
import KeyTakeaways from '../../components/events/KeyTakeaways';
import styled from 'styled-components';

const ClosingMessage = styled.div`
  background: white;
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  margin-top: 48px;
  border: 1px solid rgba(0,0,0,0.1);

  h3 {
    font-family: var(--font-serif);
    font-size: 1.5rem;
    color: var(--color-text);
    margin-bottom: 16px;
  }

  p {
    font-size: 1rem;
    color: var(--color-text-light);
    line-height: 1.6;
    max-width: 800px;
    margin: 0 auto;
  }
`;

const WelcomeApero = () => {
  const eventData = {
    title: 'Welcome Apero',
    date: '19/09/2024',
    category: 'Social',
    description: 'It was a real pleasure meeting you all! We hope you enjoyed the evening as much as we did.',
    extendedDescription: 'Our Welcome Apero was the perfect way to kick off the new academic year and introduce new members to our vibrant community. The evening was filled with laughter, meaningful conversations, and the beginning of many new friendships.',
    media: [
      { src: '/events/apero1/apero1.jpg', objectFit: 'cover', objectPosition: '50% 60%' },
      { src: '/events/apero1/apero2.jpg', objectFit: 'cover', objectPosition: 'center' },
      { src: '/events/apero1/apero3.jpg', objectFit: 'cover', objectPosition: 'center' },
      { src: '/events/apero1/apero4.jpg', objectFit: 'cover', objectPosition: '50% 70%' }
    ],
    highlights: [
      {
        icon: <People style={{ fontSize: '24px' }} />,
        title: 'New Connections',
        description: 'Met amazing new members and welcomed them into our community',
        color: '#4F8EF7'
      },
      {
        icon: <Celebration style={{ fontSize: '24px' }} />,
        title: 'Great Atmosphere',
        description: 'Perfect mix of casual conversations and celebratory moments',
        color: '#FF6B9D'
      },
      {
        icon: <EmojiEvents style={{ fontSize: '24px' }} />,
        title: 'Community Building',
        description: 'Strengthened bonds and created lasting memories together',
        color: '#50E3C2'
      }
    ]
  };

  const metaItems = [
    {
      icon: <CalendarToday style={{ fontSize: '24px' }} />,
      gradient: 'linear-gradient(135deg, #FF6B9D, #FF8A65)',
      title: new Date('2024-09-19').toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }),
      subtitle: 'Event Date'
    },
    {
      icon: <Camera style={{ fontSize: '24px' }} />,
      gradient: 'linear-gradient(135deg, #50E3C2, #4DD0E1)',
      title: `${eventData.media.length} Photos`,
      subtitle: 'Memories Captured'
    }
  ];

  return (
    <EventLayout>
      <BackButton color="#FF6B9D" />

      <EventHero
        category={eventData.category}
        title={eventData.title}
        categoryIcon={<Celebration style={{ fontSize: '16px' }} />}
      >
        <EventMeta items={metaItems} />

        <p style={{
          fontSize: '18px',
          color: '#64748b',
          lineHeight: '1.8',
          marginBottom: '24px'
        }}>
          {eventData.description}
        </p>

        <p style={{
          fontSize: '16px',
          color: '#64748b',
          lineHeight: '1.7'
        }}>
          {eventData.extendedDescription}
        </p>
      </EventHero>

      <ImageCarousel
        media={eventData.media}
        interval={4000}
        buttonGradient="linear-gradient(90deg, #FF6B9D, #FF8A65)"
      />

      <KeyTakeaways items={eventData.highlights} />

      <ClosingMessage>
        <h3>🎉 Thank You for Being Part of Our Community</h3>
        <p>
          This Welcome Apero marked the beginning of an exciting journey together. We're looking forward to many more memorable events and meaningful connections within our vibrant community!
        </p>
      </ClosingMessage>
    </EventLayout>
  );
};

export default WelcomeApero;